import React, { useEffect, useRef } from 'react';
import { Button, SelectSearchField } from 'vetrf-ui';
import classNames from 'classnames';
import { Grid } from '@mui/material';
import { useWatch } from 'react-hook-form';

import { SortOrders } from '../../types/api';
import styles from './RegistrySorting.module.scss';

type SortingFieldsProps = {
  handleSumbit: (value: SortOrders) => void;
  sortingOptions?: SortOrders[];
  isAsc: boolean;
  setIsAsc: (value: boolean) => void;
};

export const SortingFields = ({
  isAsc,
  setIsAsc,
  handleSumbit,
  sortingOptions = [],
}: SortingFieldsProps) => {
  const sortingFiled = useWatch({ name: 'sorting' });
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    } else if (sortingFiled) {
      handleSumbit(sortingFiled);
    }
  }, [isAsc, firstRender, sortingFiled]);

  return (
    <div className={styles.sortingBlockWrapper}>
      <Grid container spacing={1} alignItems="center">
        <Grid item>
          <SelectSearchField
            fieldClassName="col-xs-12 selectpicker"
            labelClassName="col-xs-12 control-label"
            labelKey="text"
            valueKey="field"
            labelText=""
            name="sorting"
            placeholder=""
            options={sortingOptions}
          />
        </Grid>
        <Grid item>
          <Button
            icon="sort-amount-asc"
            iconColor="white"
            iconSize={120}
            onlyIcon
            className={classNames({ [styles.activeSorting]: isAsc })}
            onClick={() => setIsAsc(true)}
          />
          <Button
            icon="sort-amount-desc"
            iconColor="white"
            iconSize={120}
            onlyIcon
            className={classNames({ [styles.activeSorting]: !isAsc })}
            onClick={() => setIsAsc(false)}
          />
        </Grid>
      </Grid>
    </div>
  );
};
